<style lang="less">
.daRule {
  &__title {
    font-weight: bold;
    font-size: .28rem;
    text-align: center;
  }
  &__cont {
    line-height: 1.75;
    font-size: .22rem;
  }
}
</style>
<template>
  <div class="daRule">
    <div class="daRule__title">活动说明</div>
    <div class="daRule__cont">
      <dl>
        <dd>1. 仅限非王者财经的新用户点击【注册为好友助力】完成注册助力，每3位好友完成助力，发起者和助力者均可获得1份奖励。</dd>
        <dd>2. 通过助力成为王者财经的新用户也可以发起助力活动，最多可累计11份奖励。<dd>
        <dd>3. 当天完成的3位好友助力，奖励会在第二个工作日发放。在【我的软件】中下载安装即可使用。</dd>
      </dl>
    </div>
  </div>
</template>
<script>
export default {}
</script>
